import type { CalculationResult } from '~/pages/IncomeCalculator/types';

import BreakdownYearContainer from '../styles/BreakdownYearContainer';
import AddbacksAndDeductions from './AddbacksAndDeductions';
import AnnualIncome from './AnnualIncome';
import BorrowerShareOfIncome from './BorrowerShareOfIncome';
import MedicareWages from './MedicareWages';

type AnnualBreakdownProps = {
  selectedResult: CalculationResult;
  currentYear: number;
  formulaId: number;
};

const AnnualBreakdown = ({
  selectedResult,
  currentYear,
  formulaId,
}: Readonly<AnnualBreakdownProps>) => {
  return (
    <BreakdownYearContainer title={currentYear}>
      <MedicareWages
        selectedResult={selectedResult}
        currentYear={currentYear}
      />
      <AddbacksAndDeductions
        selectedResult={selectedResult}
        currentYear={currentYear}
      />
      <BorrowerShareOfIncome
        selectedResult={selectedResult}
        currentYear={currentYear}
      />
      <AnnualIncome
        selectedResult={selectedResult}
        currentYear={currentYear}
        formulaId={formulaId}
      />
    </BreakdownYearContainer>
  );
};

export default AnnualBreakdown;
